import { FC, useState } from "react"
import { UserPlus, UserCog, Briefcase, ChevronDown } from "lucide-react"
import { LOsTableWithImporter } from "../../loan-officers"
import { useAppDispatch, useIsAdmin, useUserRoles } from "../../../hooks"
import { setVisiblePanel } from "../../../../redux/slices/app"
import Menu from "../../menu"
import MenuItem from "../../menu/item"
import CreateBrandAdminModal from "../../brand-admin/create-brand-admin-modal"
import BrandAdminsList from "../../brand-admin/brand-admins-list"

interface Props {
  brandId?: string
}

const BrandDetailsLoanOfficers: FC<Props> = ({ brandId }) => {
  const dispatch = useAppDispatch()
  const isAdmin = useIsAdmin()
  const { isSuperAdmin, isBankAdmin, user } = useUserRoles()
  const [modalOpen, setModalOpen] = useState(false)

  const canCreate =
    isSuperAdmin || (isBankAdmin && String(user?.brand_id) === String(brandId))

  return (
    <div className="p-6 bg-white">
      {canCreate && (
        <div className="flex justify-end mb-4">
          <Menu
            label={
              <span className="inline-flex items-center gap-2">
                <UserPlus size={16} />
                <span>Add User</span>
                <ChevronDown size={14} className="opacity-70" />
              </span>
            }
            buttonClassName="inline-flex items-center rounded-md bg-primary-400 hover:bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors"
          >
            <MenuItem
              label="Brand Admin"
              icon={<UserCog size={16} />}
              onClick={() => setModalOpen(true)}
            />
            <MenuItem
              label="Loan Officer"
              icon={<Briefcase size={16} />}
              onClick={() => dispatch(setVisiblePanel("loan-officer/new"))}
            />
          </Menu>
        </div>
      )}
      {brandId && <BrandAdminsList brandId={brandId} canMasquerade={isAdmin} />}
      <LOsTableWithImporter
        searchParams={{ brand_id: brandId }}
        hasMasqueradeIcon={isAdmin}
      />
      {canCreate && brandId && (
        <CreateBrandAdminModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          brandId={brandId}
        />
      )}
    </div>
  )
}

export default BrandDetailsLoanOfficers
